var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[( _vm.isShow )?_c('div',{staticClass:"mask"},[_c('div',{staticClass:"tip_modal"},[_c('div',{staticClass:"cont"},[_vm._v(_vm._s(_vm.content))]),_c('div',{staticClass:"bot",on:{"click":_vm.close}},[_vm._v("我知道了")])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }